import { Guid } from '@web/utils';
import { WarehouseReleaseStatus } from '../enums/warehouse-release-status';

export class WarehouseReleaseCollectionItem {
  public constructor(
    private readonly data: {
      canBeApproved: boolean;
      canBeEdited: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      id: Guid;
      number: string;
      productNames: string[];
      releasedAt: Date;
      status: WarehouseReleaseStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeApproved(): boolean {
    return this.data.canBeApproved;
  }

  public get number(): string {
    return this.data.number;
  }

  public get releasedAt(): Date {
    return this.data.releasedAt;
  }

  public get productNames(): string[] {
    return this.data.productNames;
  }

  public get status(): WarehouseReleaseStatus {
    return this.data.status;
  }
}
